import { Card, Grid, styled, useTheme } from '@mui/material';
import { Fragment, useState } from 'react';
import Campaigns from './shared/Campaigns';
import DoughnutChart from './shared/Doughnut';
import RowCards from './shared/RowCards';
import StatCards from './shared/StatCards';
import StatCards2 from './shared/StatCards2';
import TopSellingTable from './shared/TopSellingTable';
import UpgradeCard from './shared/UpgradeCard';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DoughnutChartBooking from './shared/DoughnutChartBooking';
import LastBooking from './shared/LastBooking';
import ShippingForm from './ShippingForm';
import {
	markupDispatch,
	showcustomerDispatch,
	showOrderDispatch,
	showProductDispatch,
} from '../../../reducers/HomeReducer';
import './dash.css';
import { addCartRowNew, removeSelectedCartNew } from 'reducers/UiReducer';
import Loader from '../../form/Loader';

const ContentBox = styled('div')(({ theme }) => ({
	margin: '30px',
	[theme.breakpoints.down('sm')]: { margin: '16px' },
}));

const Title = styled('span')(() => ({
	fontSize: '1rem',
	fontWeight: '500',
	marginRight: '.5rem',
	textTransform: 'capitalize',
}));

const SubTitle = styled('span')(({ theme }) => ({
	fontSize: '0.875rem',
	color: theme.palette.text.secondary,
}));

const H4 = styled('h4')(({ theme }) => ({
	fontSize: '1rem',
	fontWeight: '500',
	marginBottom: '16px',
	textTransform: 'capitalize',
	color: theme.palette.text.secondary,
}));

const CheckoutPage = () => {
	const { palette } = useTheme();
	const { loginInfo, customer, product, order, markup, loading } = useSelector(
		(state) => state.home
	);
	const { cart } = useSelector((state) => state.ui);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [isClicked, setIsClicked] = useState(false);
	useEffect(() => {
		dispatch(showProductDispatch());
		dispatch(markupDispatch());
	}, []);
	const totalQuantity = cart.reduce((accumulator, currentValue) => {
		return (
			accumulator +
			parseFloat(
				Number(
					Math.round(
						Number(
							Math.round(
								Number(
									Number(currentValue.set_quantity) * Number(currentValue.qnty)
								)
							)
						)
					)
				)
			)
		);
	}, 0);

	const orderQuantity = Number(markup?.result[0]?.order_quantity) || 30;

	// Calculate the remaining quantity needed to reach the next multiple
	const remainder = totalQuantity % orderQuantity;
	const remaining = remainder === 0 ? totalQuantity : totalQuantity - remainder;

	// Output result
	console.log(remainder === 0 ? totalQuantity : `Remaining: ${remaining}`);
	console.log('totalQuantity', totalQuantity);
	console.log(
		'RemianQuantity',
		Number(Number(totalQuantity) % Number(orderQuantity))
	);
	let filterData = [];
	function updateQuantities(array, order) {
		let remainingOrder = order;
		let updatedArray = array.map((item) => ({ ...item })); // Deep clone the array to avoid modifying the original

		for (let i = updatedArray.length - 1; i >= 0 && remainingOrder > 0; i--) {
			if (updatedArray[i] && updatedArray[i].qnty !== undefined) {
				// Ensure the element exists and has the qnty property
				let deduction = Math.min(updatedArray[i].qnty, remainingOrder);
				updatedArray[i].qnty -= deduction;
				remainingOrder -= deduction;
			}
		}

		// Filter out objects with qnty = 0 after the loop
		updatedArray = updatedArray.filter((item) => item.qnty > 0);
		filterData = updatedArray;
		return updatedArray;
	}

	// Example usage
	const array = [{ qnty: 8 }, { qnty: 6 }, { qnty: 3 }];
	const orderRequest = Math.round(
		Number(Number(totalQuantity) % Number(orderQuantity)) / Number(6)
	);
	console.log('cart', cart);
	console.log('hi', updateQuantities(Object.freeze(cart), orderRequest));
	console.log('filterData', filterData);
	return (
		<>
			<div
				clasName='page ps'
				style={{
					maxHeight: '100vh',
					overflowY: 'auto',
					overflowX: 'hidden',
					scrollbarWidth: 'thin',
					scrollbarColor: '#888 #f5f5f5',
					padding: 20,
				}}>
				<Grid container spacing={2}>
					<Grid item xs={6}>
						<div class='table-responsive order_table text-center'>
							<table class='table'>
								<thead>
									<tr>
										<th colspan='2'>Product</th>
										<th>Total</th>
									</tr>
								</thead>
								<tbody>
									{filterData?.map((i) => {
										return (
											<tr>
												<td class='image product-thumbnail'>
													<Link>
														<img
															src={i.imgpath}
															alt='#'
															style={{ height: '100px' }}
														/>
														<br />
														<span>Size Preference :- {i.size}</span>
													</Link>
												</td>
												<td>
													<h5>
														<Link>
															<a>{i.name}</a>
														</Link>
													</h5>{' '}
													<span class='product-qty'>
														{`${i.set_quantity} x ${i.qnty}=${
															Number(i.set_quantity) * Number(i.qnty)
														}`}
													</span>
												</td>
												<td>
													₹
													{Number(
														Math.round(
															Number(Number(i.set_quantity) * Number(i.qnty)) *
																Number(Number(i?.price_per))
														)
													)}
												</td>
											</tr>
										);
									})}
									<tr>
										<td className='cart_total_label'>Total Order Pcs</td>
										<td className='cart_total_amount' colspan='2'>
											<span className='font-lg fw-900 text-brand'>
												{`${
													Number(totalQuantity) -
													Number(Number(totalQuantity) % Number(orderQuantity))
												} (${Number(
													Math.floor(
														Number(Number(totalQuantity)) /
															Number(
																parseInt(markup?.result[0]?.order_quantity)
															)
													)
												)} Parcel) `}
											</span>
										</td>
									</tr>
									{Number(Number(totalQuantity) % Number(orderQuantity)) ===
									0 ? (
										''
									) : (
										<tr>
											<td className='cart_total_label'>Remaining Cart Pcs</td>
											<td className='cart_total_amount' colspan='2'>
												<span className='font-lg fw-900 text-brand'>
													{`${Number(
														Number(totalQuantity) % Number(orderQuantity)
													)}  `}
												</span>
												<span>{`(add more ${Number(
													Number(orderQuantity) -
														Number(
															Number(totalQuantity) % Number(orderQuantity)
														)
												)} PCS to complete parcel)`}</span>
											</td>
										</tr>
									)}
									<tr>
										<th>SubTotal</th>
										<td class='product-subtotal' colspan='2'>
											₹
											{Number(
												filterData?.reduce((accumulator, currentValue) => {
													return (
														accumulator +
														parseFloat(
															Number(
																Math.round(
																	Number(
																		Math.round(
																			Number(
																				Number(currentValue.set_quantity) *
																					Number(currentValue.qnty)
																			) * Number(currentValue.price_per)
																		)
																	)
																)
															)
														)
													);
												}, 0)
											)}
										</td>
									</tr>
									<tr>
										<th>Shipping</th>
										<td colspan='2'>
											<em>Free Shipping</em>
										</td>
									</tr>
									<tr>
										<td>{`Gst (${markup?.result[0]?.gst}%)`}</td>
										<td colspan='2'>
											₹
											{Number(
												filterData?.reduce((accumulator, currentValue) => {
													return (
														accumulator +
														parseFloat(
															Number(
																Math.round(
																	Number(
																		Math.round(
																			Number(
																				Number(
																					Math.round(
																						Number(
																							Math.round(
																								Number(
																									Number(
																										currentValue.set_quantity
																									) * Number(currentValue.qnty)
																								) *
																									Number(currentValue.price_per)
																							)
																						)
																					)
																				)
																			) *
																				Number(parseInt(markup?.result[0]?.gst))
																		)
																	) / 100
																)
															)
														)
													);
												}, 0)
											)}
										</td>
									</tr>
									<tr>
										<th>Total</th>
										<td colspan='2' class='product-subtotal'>
											<span class='font-xl text-brand fw-900'>
												₹
												{Number(
													filterData?.reduce((accumulator, currentValue) => {
														return (
															accumulator +
															parseFloat(
																Number(
																	Math.round(
																		Number(
																			Math.round(
																				Number(
																					Number(currentValue.set_quantity) *
																						Number(currentValue.qnty)
																				) * Number(currentValue.price_per)
																			)
																		)
																	)
																)
															)
														);
													}, 0)
												) +
													Number(
														filterData?.reduce((accumulator, currentValue) => {
															return (
																accumulator +
																parseFloat(
																	Number(
																		Math.round(
																			Number(
																				Math.round(
																					Number(
																						Number(
																							Math.round(
																								Number(
																									Math.round(
																										Number(
																											Number(
																												currentValue.set_quantity
																											) *
																												Number(
																													currentValue.qnty
																												)
																										) *
																											Number(
																												currentValue.price_per
																											)
																									)
																								)
																							)
																						)
																					) *
																						Number(
																							parseInt(markup?.result[0]?.gst)
																						)
																				)
																			) / 100
																		)
																	)
																)
															);
														}, 0)
													)}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</Grid>
					<Grid item xs={6}>
						<ShippingForm filterData={filterData} />
					</Grid>
				</Grid>
			</div>
			{loading ? <Loader /> : ''}
		</>
	);
};

export default CheckoutPage;
